document.addEventListener("DOMContentLoaded", function() {
  const updatePaymentLink = () => {
    const link = document.getElementById("more-payment-options-link");
    if (link) {
      link.textContent = "All major payment methods accepted";
      link.removeAttribute("href");
      link.style.pointerEvents = "none";
      link.style.cursor = "default";
      return true;
    }
    return false;
  };

  // Try immediately
  if (!updatePaymentLink()) {
    // Keep checking until it appears (every 300ms, stop after 10s)
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      if (updatePaymentLink() || attempts > 30) {
        clearInterval(interval);
      }
    }, 300);
  }
});
